<script>
  export let size = '48px';
  export let slim = false;
  export let micro = false;
</script>

<span class="loader" style:height={size} style:width={size} style:min-height={size} style:min-width={size} class:slim class:micro></span>

<style>
  .loader {
    background: #fff;
    border-radius: 50%;
    position: relative;
    animation: spinner 1s ease-in-out infinite alternate;
    border: 1px solid var(--gainsboro);
  }
  .loader:after {
    content: '';
    position: absolute;
    inset: 5px;
    border-radius: 50%;
    border: 5px solid transparent;
    border-top-color: var(--magic-potion);
  }
  .slim.loader:after {
    inset: 3px;
    border: 3px solid transparent;
    border-top-color: var(--magic-potion);
  }
  .micro.loader:after {
    inset: 1px;
    border: 2px solid transparent;
    border-top-color: var(--magic-potion);
  }
  @keyframes spinner {
    95%,
    100% {
      transform: rotate(840deg);
    }
  }
</style>
